import "./SingleSubproductoTemplate.module.css"
import Header from "@/reusable_sections/Header"
import SingleSubproductoTemplateSection from "./sections/SingleSubproductoTemplateSection"
import Footer from "@/reusable_sections/Footer"

export default function SingleSubproductoTemplatePage() {

  return (
    <div>
      <Header />
      <SingleSubproductoTemplateSection />
      <Footer />
    </div>
  )
}
